import { render, staticRenderFns } from "./LeavingApproval.vue?vue&type=template&id=1f82f858&scoped=true"
import script from "./LeavingApproval.vue?vue&type=script&lang=js"
export * from "./LeavingApproval.vue?vue&type=script&lang=js"
import style0 from "./LeavingApproval.vue?vue&type=style&index=0&id=1f82f858&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f82f858",
  null
  
)

export default component.exports